export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/ben-white-24269ffcf1d4e7e583c1802bfdd23a1c.jpg";